export default "__VITE_ASSET__hEW_X9cm__"